export const hasGroup = (terminal) => terminal.groupId !== null && terminal.groupId !== undefined && terminal.groupId !== ""

export const assignmentOrganization = (terminals) => {
  if (!terminals.length || terminals.some((terminal) => !terminal.orgCode || !terminal.serialNo)) {
    throw new Error("Select terminals with an organization and serial number.")
  }
  const orgCode = terminals[0].orgCode
  if (terminals.some((terminal) => terminal.orgCode !== orgCode)) {
    throw new Error("Select terminals from one organization. Transfers between organizations are not supported.")
  }
  return orgCode
}

export const buildTerminalAssignment = (terminals, mode, destination, groups) => {
  const orgCode = assignmentOrganization(terminals)
  if (!["assign", "unassign"].includes(mode)) throw new Error("Choose an assignment action.")
  const target = groups.find((group) => String(group.groupId) === String(destination) &&
    (!group.orgCode || group.orgCode === orgCode))
  if (mode === "assign" && (!target || destination === "")) {
    throw new Error("Choose a destination group in this organization.")
  }
  const changed = terminals.filter((terminal) => mode === "unassign" ? hasGroup(terminal) :
    !hasGroup(terminal) || String(terminal.groupId) !== String(target.groupId))
  if (!changed.length) throw new Error(mode === "unassign" ? "These terminals are already unassigned." : "These terminals already belong to the selected group.")
  return {
    orgCode,
    unAssignTerminalSnList: changed.filter(hasGroup).map((terminal) => ({ terminalSn: terminal.serialNo, groupId: terminal.groupId })),
    assignTerminalSnList: mode === "assign" ? changed.map((terminal) => ({ terminalSn: terminal.serialNo, groupId: target.groupId })) : [],
  }
}
